<template>
  <div class="home homeMain">
    <swiper class="swiper"></swiper>
    <banner></banner>
    <!-- <div style="padding-top:20px;"></div> -->
    <!-- <div class="top-box"> </div> -->
    <div class="home-bar">
      <div
        class="home-bar-item"
        @click="goPage(item)"
        v-for="(item, index) in navLists"
      >
        <img :src="item.img" style="" alt="" />
      </div>
      <!-- <div class="home-bar-item">
        <img src="@/assets/home/a2.png" style="" alt="">
      </div>
      <div class="home-bar-item">
        <img src="@/assets/home/a3.png" style="" alt="">
      </div>
      <div class="home-bar-item">
        <img src="@/assets/home/a4.png" style="" alt="">
      </div>
      <div class="home-bar-item">
        <img src="@/assets/home/a5.png" style="" alt="">
      </div> -->
    </div>
    <div class="home-content">
      <img src="@/assets/home/xy.gif" @click="goLucky" class="xy-img" alt="" />
      <img src="@/assets/home/mh.gif" @click="goBattle" class="mh-img" alt="" />
      <img
        src="@/assets/home/left.gif"
        @click="goBoxes"
        class="left-img"
        alt=""
      />
      <img
        src="@/assets/home/right.gif"
        @click="goRoll"
        class="right-img"
        alt=""
      />
    </div>
    <!-- 空盒子 -->
    <!-- <banner></banner> -->
    <!-- 导航栏 -->
    <!-- <div class="home-nav-list-new">
      <div
        class="nav-item"
        @click="goPage(item)"
        :class="[item.class]"
        v-for="(item, index) in navLists"
        :key="index"
      >
        <div class="nav-title" style="color: #fff">
          {{ item.name }}
        </div>
        <div class="touch-box"></div>
      </div>
    </div> -->
    <!-- home-nav导航栏 -->
    <!-- <div class="home-nav">
      <div class="nav-list2">
        <div class="entry-box1">
          <div class="top-img">
            <div class="item box-item">
              <img class="abs-full img" src="../assets/images/nav_2_0.gif" />
            </div>
            <div class="item lucky-item"></div>
            <div class="item pk-item"></div>
          </div>
          <div class="btm-title">
            <div class="tv box-tv"></div>
            <div class="tv lucky-tv"></div>
            <div class="tv pk-tv"></div>
          </div>
          <div class="touch-layer">
            <div class="touch-box" @click="goBoxes"></div>
            <div class="touch-lucky" @click="goRoll"></div>
            <div class="touch-battle" @click="goLucky"></div>
          </div>
        </div>
        <div class="entry-box2">
          <div class="abs-base pk-img"></div>
          <div class="abs-full bk-img"></div>
          <div class="card-img"></div>
          <div class="layer2-box">
            <div class="tv card-tv"></div>
          </div>
          <div class="touch-layer">
            <div class="touch-card" @click="goBattle"></div>
          </div>
        </div>
      </div>
    </div> -->

    <!-- <div class="body_title">
      <div class="body_btn">
        <router-link to="/open" tag="div" class="btn openBox">
          <div class="btns">
            <div>玩转盲盒</div>
          </div>
        </router-link>
        <router-link to="/pk" tag="div" class="btn jsjj">
          <div class="btns">
            <div>急速竞技</div>
          </div>
        </router-link>
        <router-link to="/roll" tag="div" class="btn roll">
          <div class="btns">
            <div>ROLL房</div>
          </div>
        </router-link>
        <router-link to="/dream" tag="div" class="btn zmqx">
          <div class="btns">
            <div>逐梦前行</div>
          </div>
        </router-link>
      </div>
    </div>
    <div class="kf-item" @click="customerService">在线客服</div> -->
    <!-- <div class="body_bottom">
      <div class="body_bottom_top">
        <div
          class="title"
          v-for="(item, index) in articleList"
          :key="index"
          @click="handleTo(item.id)"
        >
          {{ item.title }}
        </div>
      </div>
      <div class="body_bottom_bottom">
      </div>
    </div> -->
    <openBox v-if="showOpenBox"></openBox>
    <!-- 福利 -->
    <modalBonus :showModal="showBonus" @close="showBonus = false"></modalBonus>
    <!-- 排行榜 -->
    <modalLeaderboard
      :showModal="showLeaderboard"
      @close="showLeaderboard = false"
    ></modalLeaderboard>
    <!-- 消息列表 -->
    <modalMessage
      :showModal="showMessage"
      @close="showMessage = false"
    ></modalMessage>
  </div>
</template>

<script>
// @ is an alias to /src
import swiper from "@/components/swiperUser.vue";
import banner from "@/components/bannerUser.vue";
import openBox from "@/components/common/openBox.vue";
import modalBonus from "@/components/common/modalBonus.vue";
import modalLeaderboard from "@/components/common/modalLeaderboard.vue";
import modalMessage from "@/components/common/modalMessage.vue";
import customer from "../../public/config.json";
import { getArticle } from "@/api/index";
export default {
  data() {
    return {
      articleList: [],
      show: true,
      navLists: [
        {
          class: "mall",
          name: "商城",
          img: require("@/assets/home/a1.png"),
        },
        {
          class: "welfare",
          name: "福利",
          img: require("@/assets/home/a2.png"),
        },
        {
          class: "rank",
          name: "排行",
          img: require("@/assets/home/a3.png"),
        },
        {
          class: "msg",
          name: "消息",
          img: require("@/assets/home/a4.png"),
        },
        {
          class: "kf",
          name: "客服",
          img: require("@/assets/home/a5.png"),
        },
      ],
      showOpenBox: false,
      showBonus: false,
      showLeaderboard: false,
      showMessage: false,
      customerServiceAddress: {
        url: "http://kefu.a7cs2.com/chat/index",
        noCanClose: 1,
        kefu_id: 1,
        token: "17ab2e53e3d171291fd0be33a335f412",
      },
    };
  },
  components: {
    swiper,
    banner,
    openBox,
    modalBonus,
    modalLeaderboard,
    modalMessage,
  },
  mounted() {
    this.getArticle();
  },
  methods: {
    goPage(item) {
      this.$soundPlay("click");
      switch (item.class) {
        case "mall":
          this.$router.push({ name: "shopping" });
          break;
        case "welfare":
          // this.$message({ duration: 1000,
          //   message: "暂未开放",
          //   type: "warning",
          //   customClass: "log_warning",
          // });
          // // this.getWelfare();
          // this.$refs.fuli.open();
          this.showBonus = true;
          break;
        case "rank":
          this.showLeaderboard = true;
          // this.$message({ duration: 1000,
          //   message: "暂未开放",
          //   type: "warning",
          //   customClass: "log_warning",
          // });
          // this.getRank();
          // this.$refs.rankPopup.open();
          break;
        case "kf":
          this.customerService();
          // if (this.checkLogin()) {
          //   this.$router.push({ name: "kefu" });
          // }

          break;
        case "msg":
          this.showMessage = true;
          // this.$message({ duration: 1000,
          //   message: "暂未开放",
          //   type: "warning",
          //   customClass: "log_warning",
          // });
          // if (this.checkLogin()) {
          //   this.showMessage = true;
          // }
          break;
      }
    },
    // 检查是否登录
    showOpenBoxLoading(callback) {
      this.$soundPlay("doorClose");
      this.showOpenBox = true;
      setTimeout(() => {
        this.$soundPlay("doorOpen");
        this.showOpenBox = false;
        callback && callback();
      }, 1500);
    },
    goBoxes() {
      this.showOpenBoxLoading(() => {
        this.$router.push({ name: "open" });
      });
    },
    goRoll() {
      this.showOpenBoxLoading(() => {
        this.$router.push({ name: "roll" });
      });
    },
    goLucky() {
      this.showOpenBoxLoading(() => {
        this.$router.push({ name: "dream" });
      });
    },
    goBattle() {
      this.showOpenBoxLoading(() => {
        // this.$message({ duration: 1000,
        //   message: "暂未开放",
        //   type: "warning",
        //   customClass: "log_warning",
        // });
        // return;
        this.$router.push({ name: "pk" });
      });
    },
    goExponent() {},
    handleTo(e) {
      if (e == 2 || e == 5) {
        localStorage.setItem("help-type", "yhxy");
      } else if (e == 9) {
        localStorage.setItem("help-type", "bzzx");
      } else {
        localStorage.setItem("help-type", "gywm");
      }
      this.$router.push({
        path: "/help",
      });
    },
    getArticle() {
      getArticle("sydb").then((res) => {
        this.articleList = res.data.data.contentList;
      });
    },
    customerService() {
      window.location.href = `http://wpa.qq.com/msgrd?v=3&uin=444827929&site=qq&menu=yes`;
      // const userInfo = JSON.parse(localStorage.getItem("userInfo"));
      // const customerServiceAddress = this.customerServiceAddress;
      // console.log(customerServiceAddress, "测试数据222");
      // const url = customerServiceAddress.url;
      // const noCanClose = customerServiceAddress.noCanClose;
      // const kefu_id = customerServiceAddress.kefu_id;
      // const token = customerServiceAddress.token;
      // if (userInfo) {
      //   window.location.href = `${url}?noCanClose=${noCanClose}&token=${token}&kefu_id=${kefu_id}&phone=${userInfo.mobile}&nickName=${userInfo.name}`;
      // } else {
      //   window.location.href = `${url}?noCanClose=${noCanClose}&token=${token}&kefu_id=${kefu_id}`;
      // }
    },
  },
};
</script>
<style scoped lang="scss">
.homeMain {
  background: url("../assets/home/bj.png") no-repeat center center !important;
  // background-size: 100% 100% !important;
  background-size: cover !important;
  height: calc(100vh - 130px);
  position: relative;
  overflow-y: scroll;

  .top-box {
    margin-left: 20px;
    margin-right: 20px;
    // width: 343px;
    height: 226px;
    background: url("../assets/home/100.png") no-repeat center center !important;
    background-size: cover !important;
  }

  .home-bar {
    margin: 0 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .home-bar-item {
      flex: 1;

      img {
        // width: 66px;
        width: 15.714 * 4.2px;
        height: auto;

        @media only screen and (max-width: 430px) {
          height: 9vh;
          width: auto;
        }
      }
    }
  }

  .home-content {
    position: relative;

    // margin-top: -1vh;
    @media only screen and (max-width: 430px) {
      width: 100%;
      height: 60vh;
    }
    .xy-img {
      position: absolute;
      top: 1vh;
      left: 50%;
      transform: translateX(-50%);
      width: auto;
      height: 140px;

      @media only screen and (max-width: 430px) {
        height: 16vh;
      }

      // height: 110px;
    }

    .mh-img {
      position: absolute;
      top: 23vh;
      left: 50%;
      transform: translateX(-50%);
      width: auto;
      height:140px;

      @media only screen and (max-width: 430px) {
        height: 16vh;
      }

      // height: 200px;
    }

    .left-img {
      position: absolute;
      // top: 170px;
      top: 16vh;
      left: 1vh;
      width: auto;
      // height: 210px;
      height: 140px;

      @media only screen and (max-width: 430px) {
        height: 16vh;
      }
    }

    .right-img {
      position: absolute;
      top: 16vh;
      right: 1vh;
      width: auto;
      // height: 210px;
      height: 140px;

      @media only screen and (max-width: 430px) {
        height: 16vh;
      }
    }
  }
}

.anima {
  animation-name: likes; // 动画名称
  animation-direction: alternate; // 动画在奇数次（1、3、5...）正向播放，在偶数次（2、4、6...）反向播放。
  animation-timing-function: linear; // 动画执行方式，linear：匀速；ease：先慢再快后慢；ease-in：由慢速开始；ease-out：由慢速结束；ease-in-out：由慢速开始和结束；
  animation-delay: 0s; // 动画延迟时间
  animation-iteration-count: infinite; //  动画播放次数，infinite：一直播放
  animation-duration: 1s; // 动画完成时间
}

@keyframes likes {
  0% {
    transform: scale(1);
  }

  25% {
    transform: scale(0.9);
  }

  50% {
    transform: scale(0.85);
  }

  75% {
    transform: scale(0.9);
  }

  100% {
    transform: scale(1);
  }
}

@media (max-width: 550px) {
  .hudong {
    width: 172px !important;
    height: 123px !important;
  }

  .body_bottom {
    margin-top: 55px !important;
  }

  // .btn {
  //   height: 147px !important ;
  //   // background: red !important;

  //   .btns {
  //     width: 100px !important;
  //     height: 25px !important;
  //     font-size: 12px !important;
  //     border-radius: 10px !important;
  //     left: 10px !important;
  //     bottom: 10px !important;

  //     .btns_icon {
  //       width: 14px !important;
  //       height: 14px !important;
  //     }
  //   }
  // }
  // .openBox {
  //   width: 50% !important;
  //   height: 147px !important;
  // }
}

.hudong {
  width: 241px;
  height: 172px;
  position: absolute;
  right: 0;
  bottom: 0;
  background-image: url("../assets/hudong.png");
  background-size: contain;
  // transform: rotateX(50deg);
}

.jsjj {
  // position: absolute;
  // right: 0;
  // bottom: 0;
  background: url("../assets/jsjj.png") no-repeat;
  background-size: contain;
  // transform: rotateX(50deg);
  right: 12px;
  bottom: 25vh;
  // transform: rotateY(180deg);
  // padding: 12px 20px 12px 16.6px !important;
}

.roll {
  right: 12px;
  bottom: 50vh;
  // padding: 12px 20px 12px 16.6px !important;
  // transform: rotateY(180deg);
  // position: absolute;
  // position: absolute;
  // right: 0;
  // bottom: 0;
  background: url("../assets/roll.png") no-repeat;
  background-size: contain;
  padding-top: 30px !important;
  // transform: rotateX(50deg);
}

.zmqx {
  left: 24px;
  bottom: 25vh;

  // position: absolute;
  // right: 0;
  // bottom: 0;
  background: url("../assets/zmqx.png") no-repeat;
  background-size: contain;
  // transform: rotateX(50deg);
}

.body_title {
  margin: 0 auto;
  width: 90%;
  text-align: left;
  margin-top: 10px;
}

.body_title .body_btn .btn {
  position: absolute;
  width: 92px;
  height: 92px;
  // line-height:60px;
  // font-size: 3.467*4.2px;
  padding: 19px 32.5px 7px 25px;
  text-align: center;
  box-sizing: border-box;
  font-weight: 600;
  color: #ebebeb;
}

// .body_title .body_btn .btn::after{
//   z-index: -1;
//   content: "";
//   width: 100%;
//   height: 100%;
//   position: absolute;
//   top: 0;
//   left: 0;
//   background-size: 100% 100%;
//   background: url("../assets/game_bg.png") no-repeat center center;
//   background-size: 100% 100%;
// }

// .body_title .body_btn .jsjj::after,
// .body_title .body_btn .roll::after {

//   transform: rotateY(180deg);
// }
// .body_title .body_btn .btn::before{
//   opacity: 0;
//     z-index:0;
//     content: "";
//     position: absolute;
//     top: 0;
//     left: 0;
//     width: 100%;
//     height: 100%;
//     background-size: 100% 100%;
//     background-image: url('../assets/item_light.png');
//     animation:gameEntryItemKf01 5s infinite 0s forwards;
// }
// .body_title .body_btn .jsjj::before,
// .body_title .body_btn .roll::before {

//   transform: rotateY(180deg);
// }
// .body_title .body_btn .roll div,
// .body_title .body_btn .jsjj div {
//   transform: rotateY(-180deg);
// }
.body_title .body_btn .openBox {
  left: 24px;
  bottom: 50vh;
  // position: relative;
  // // height: 140px;
  background: url("../assets/openbox.png");
  background-repeat: no-repeat;
  background-size: contain;
  padding-top: 30px;
}

.body_btn {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  .btn {
    // margin: 0 auto;
    width: 48%;
    height: 182px;
    margin-top: 12px;
    position: relative;
    // border: 1px solid red;
    // border-radius: 10px;
    // box-shadow: 0px 0px 5px 10px rgba(0, 0, 0, 0.1);
    // box-shadow: 4px 4px 11px 1px rgba(0, 0, 0, 0.7);
    // opacity: 0.7;

    &:hover {
      transition: all 0.3s ease-in-out;
      opacity: 1;
    }

    &:not(:hover) {
      transition: all 0.3s ease-in-out;
    }

    // /* 第一个阴影 */ 4px 4px 6px rgba(0, 0, 0, 0.7);
    // box-shadow: 20px 20px 60px #141618, -20px -20px 60px #1c1e20;
    // .btns {
    //   position: absolute;
    //   left: 14px;
    //   bottom: 14px;
    //   width: 140px;
    //   height: 35px;
    //   background: rgba(16, 17, 21, 0.5);
    //   box-shadow: 0px 0 11px 0px rgba(0, 0, 0, 0.25);
    //   border-radius: 70px 70px 70px 70px;
    //   font-size: 17px;
    //   display: flex;
    //   align-items: center;
    //   justify-content: center;
    //   .btns_icon {
    //     width: 18px;
    //     height: 18px;
    //     margin-right: 8px;
    //   }
    // }
  }
}

.body_bottom {
  margin-top: 77px;
  border-top: 1px solid #323436;

  .body_bottom_top {
    width: 70%;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-around;
    font-size: 14px;
    color: #ffffff;
    line-height: 4;
    flex-wrap: wrap;

    @media (max-width: 550px) {
      font-size: 10px;
    }

    .title {
      position: relative;
    }

    .title::after {
      border-right: 1px solid #323436;
      content: "";
      display: block;
      width: 1px;
      height: 20px;
      position: absolute;
      top: 50%;
      margin-top: -10px;
      right: -18px;
      color: #323436;
      line-height: 1;

      @media (max-width: 550px) {
        right: -13px;
        height: 15px;
        margin-top: -7.5px;
      }
    }

    .title:last-child::after {
      display: none;
    }

    .shu {
      color: #323436;
    }
  }

  .body_bottom_bottom {
    text-align: center;
    font-size: 13px;

    @media (max-width: 550px) {
      font-size: 10px;
    }
  }
}

@keyframes gameEntryItemKf01 {
  0% {
    opacity: 0;
  }

  5% {
    opacity: 0.5;
  }

  7% {
    opacity: 0;
  }

  9% {
    opacity: 0.5;
  }

  11% {
    opacity: 0;
  }

  25% {
    opacity: 1;
  }

  75% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}

.kf-item {
  position: absolute;
  bottom: 104px;
  left: 50%;
  width: 70px;
  height: 70px;
  line-height: 70px;
  background-size: 100% 100%;
  background-image: url("../assets/kf_bg.png");
  transform: translateX(-50%);
}

// 导航栏
.home-nav-list-new {
  position: relative;
  height: 19.2 * 4.2px;
  margin-top: 5.07 * 4.2px;

  @media only screen and (max-width: 430px) {
    height: 19.2vw;
    margin-top: 5.07vw;
  }
}

.home-nav-list-new .nav-item {
  position: relative;
  width: 13.6 * 4.2px;
  height: 14.27 * 4.2px;
  background-size: 100% 100%;
  background-repeat: no-repeat;

  @media only screen and (max-width: 430px) {
    width: 13.6vw;
    height: 14.27vw;
  }
}

.home-nav-list-new .nav-item .notread {
  position: absolute;
  top: 0;
  left: 0;
  width: 4 * 4.2px;
  height: 4 * 4.2px;
  background: red;
  border-radius: 50%;
  font-size: 2vw;
  color: #fff;
  line-height: 4vw;
  text-align: center;

  @media only screen and (max-width: 430px) {
    width: 4vw;
    height: 4vw;
    font-size: 2vw;
  }
}

.home-nav-list-new .nav-item.hidden {
  display: none;
}

.home-nav-list-new .nav-item .nav-title {
  width: 13.6 * 4.2px;
  height: 4 * 4.2px;
  line-height: 4 * 4.2px;
  text-align: center;
  font-size: 3.33 * 4.2px;
  margin: 9.33 * 4.2px 0 0 0;
  position: relative;

  @media only screen and (max-width: 430px) {
    width: 13.6vw;
    height: 4vw;
    line-height: 4vw;
    font-size: 3.33vw;
    margin: 9.33vw 0 0 0;
  }
}

.home-nav-list-new .nav-item .nav-title div {
  display: none;
}

.home-nav-list-new .nav-item .nav-title .dot {
  display: block;
  position: absolute;
  font-size: 2.67 * 4.2px;
  text-align: center;
  font-style: italic;
  width: 6.67 * 4.2px;
  height: 3.6 * 4.2px;
  line-height: 3.6 * 4.2px;
  top: -10 * 4.2px;
  right: -2.93 * 4.2px;
  background: #eb2068;
  -webkit-transform: skewX(335deg) scale(0.9);
  -ms-transform: skewX(335deg) scale(0.9);
  transform: skewX(335deg) scale(0.9);
  padding: 0 0.67 * 4.2px;

  @media only screen and (max-width: 430px) {
    font-size: 2.67vw;
    width: 6.67vw;
    height: 3.6vw;
    line-height: 3.6vw;
  }
}

.home-nav-list-new .nav-item .nav-title .dot div {
  -webkit-transform: skewX(25deg);
  -ms-transform: skewX(25deg);
  transform: skewX(25deg);
  display: block;
}

.home-nav-list-new .nav-item .nav-title .dot::before {
  content: "";
  position: absolute;
  top: -0.67 * 4.2px;
  left: 0;
  width: 8.13 * 4.2px;
  height: 1px;
  background: -webkit-gradient(
    linear,
    left top,
    right top,
    from(#c986a7),
    to(#eb2068)
  );
  background: -webkit-linear-gradient(left, #c986a7, #eb2068);
  background: -o-linear-gradient(left, #c986a7, #eb2068);
  background: linear-gradient(to right, #c986a7, #eb2068);

  @media only screen and (max-width: 430px) {
    width: 8.13vw;
    top: -0.67vw;
  }
}

.home-nav-list-new .nav-item .touch-box {
  position: absolute;
  top: 5%;
  left: 5%;
  width: 90%;
  height: 90%;
}

.home-nav-list-new .nav-item.mall {
  position: absolute;
  top: 0;
  left: 6.27 * 4.2px;
  background-image: url("../assets/images/nav_sel.png");

  @media only screen and (max-width: 430px) {
    left: 6.27vw;
  }
}

.home-nav-list-new .nav-item.mall .touch-box {
  background: url("../assets/images/nav/mall.png") no-repeat 4 * 4.2px 3.33 *
    4.2px;
  background-size: 4.27 * 4.2px 4 * 4.2px;

  @media only screen and (max-width: 430px) {
    background-size: 4.27vw 4vw;
  }
}

.home-nav-list-new .nav-item.mall:active {
  background-image: url("../assets/images/nav_select.png");
}

.home-nav-list-new .nav-item.welfare {
  position: absolute;
  left: 24.8 * 4.2px;
  background-image: url("../assets/images/home-list-icon.png");

  @media only screen and (max-width: 430px) {
    left: 24.8vw;
  }
}

.home-nav-list-new .nav-item.welfare .touch-box {
  background: url("../assets/images/nav/welfare.png") no-repeat 4 * 4.2px 3.33 *
    4.2px;
  background-size: 4.27 * 4.2px 4 * 4.2px;

  @media only screen and (max-width: 430px) {
    background-size: 4.27vw 4vw;
  }
}

.home-nav-list-new .nav-item.welfare:active {
  background-image: url("../assets/images/nav_select.png");
}

.home-nav-list-new .nav-item.rank {
  position: absolute;
  top: 0;
  left: 43.33 * 4.2px;
  background-image: url("../assets/images/home-list-icon.png");

  @media only screen and (max-width: 430px) {
    left: 43.33vw;
  }
}

.home-nav-list-new .nav-item.rank .touch-box {
  background: url("../assets/images/nav/rank.png") no-repeat 4 * 4.2px 3.33 *
    4.2px;
  background-size: 4.27 * 4.2px 4 * 4.2px;

  @media only screen and (max-width: 430px) {
    background-size: 4.27vw 4vw;
  }
}

.home-nav-list-new .nav-item.rank:active {
  background-image: url("../assets/images/nav_select.png");
}

.home-nav-list-new .nav-item.msg {
  position: absolute;
  left: 61.87 * 4.2px;
  background-image: url("../assets/images/home-list-icon.png");

  @media only screen and (max-width: 430px) {
    left: 61.87vw;
  }
}

.home-nav-list-new .nav-item.msg .touch-box {
  background: url("../assets/images/nav/msg.png") no-repeat 4 * 4.2px 3.33 *
    4.2px;
  background-size: 4.27 * 4.2px 4 * 4.2px;

  @media only screen and (max-width: 430px) {
    background-size: 4.27vw 4vw;
  }
}

.home-nav-list-new .nav-item.msg:active {
  background-image: url("../assets/images/nav_select.png");
}

.home-nav-list-new .nav-item.kf {
  position: absolute;
  top: 0;
  left: 80.4 * 4.2px;
  background-image: url("../assets/images/home-list-icon.png");

  @media only screen and (max-width: 430px) {
    left: 80.4vw;
  }
}

.home-nav-list-new .nav-item.kf .touch-box {
  background: url("../assets/images/nav/kf.png") no-repeat 4 * 4.2px 3.33 *
    4.2px;
  background-size: 4.27 * 4.2px 4 * 4.2px;

  @media only screen and (max-width: 430px) {
    background-size: 4.27vw 4vw;
  }
}

.home-nav-list-new .nav-item.kf:active {
  background-image: url("../assets/images/nav_select.png");
}

.home-nav-list-new .nav-item text {
  font-size: 3.2 * 4.2px;
  color: #c9d5e5;

  @media only screen and (max-width: 430px) {
    font-size: 3.2vw;
  }
}

.home-nav-list-new .nav-item:active text {
  color: #e9c66d;
}

.home-nav-list-new .weui-dialog {
  max-width: 80% !important;
  background: none;
}

.home-nav-list-new .kefu-qq-tip-wrap {
  width: 100%;
  height: 40 * 4.2px;
  background-color: #22263c;
  margin: 0 auto;
  -webkit-border-radius: 1.07 * 4.2px;
  border-radius: 1.07 * 4.2px;
  overflow: hidden;
  position: relative;
}

.home-nav-list-new .kefu-qq-tip-wrap .dialog-close-btn {
  position: absolute;
  right: 0px;
  top: 0px;
}

.home-nav-list-new .kefu-qq-tip-wrap .dialog-close-btn .vux-x-icon {
  fill: #91a1da;
  font-weight: 600;
}

.home-nav-list-new .kefu-qq-tip-wrap .kefu-qq-tip-content {
  padding-top: 10.67 * 4.2px;

  @media only screen and (max-width: 430px) {
    padding-top: 10.67vw;
  }
}

.home-nav-list-new .kefu-qq-tip-wrap .kefu-qq-tip-content > div {
  color: #91a1da;
  margin-bottom: 2.67 * 4.2px;
  font-size: 4.53 * 4.2px;

  @media only screen and (max-width: 430px) {
    margin-bottom: 2.67vw;
  }
}

.home-nav-list-new .kefu-qq-tip-wrap .kefu-qq-tip-content > div p {
  display: inline-block;
}

.home-nav-list-new .kefu-qq-tip-wrap .dialog-btn {
  width: 90%;
  height: 10.67 * 4.2px;
  line-height: 10.67 * 4.2px;
  background-color: #393782;
  margin: 0 5%;
  float: left;
  margin-top: 4 * 4.2px;
  -webkit-border-radius: 1.07 * 4.2px;
  border-radius: 1.07 * 4.2px;
  color: #c3c3e2;
  font-weight: 600;
  font-size: 3.73 * 4.2px;

  @media only screen and (max-width: 430px) {
    height: 10.67vw;
    line-height: 10.67vw;
    margin-top: 4vw;
    font-size: 3.73vw;
    border-radius: 1.07wv;
  }
}

.home-nav-list-new .kefu-qq-tip-wrap .dialog-btn:active {
  opacity: 0.8;
}

// home-nav导航栏
.nav-list2 {
  margin-top: 2 * 4.2px;

  @media only screen and (max-width: 430px) {
    margin-top: 2vw;
  }
}

.nav-list2 .entry-box1 {
  position: relative;
  height: 24.8 * 4.2px;
  background-position: center bottom;
  background-repeat: no-repeat;
  background-size: 94.8 * 4.2px 19.47 * 4.2px;
  background-image: url("../assets/images/n2_img1.png");

  @media only screen and (max-width: 430px) {
    height: 24.8vw;
    background-size: 94.8vw 19.47vw;
  }
}

.nav-list2 .entry-box1 .top-img {
  position: relative;
  height: 14.53 * 4.2px;

  @media only screen and (max-width: 430px) {
    height: 14.53vw;
  }
}

.nav-list2 .entry-box1 .top-img .item {
  float: left;
  width: 14.8 * 4.2px;
  height: 14.53 * 4.2px;
  background-size: 100% 100%;
  -webkit-animation: navItemKf 2s linear infinite;
  animation: navItemKf 2s linear infinite;

  @media only screen and (max-width: 430px) {
    width: 14.8vw;
    height: 14.53vw;
  }
}

@-webkit-keyframes navItemKf {
  0% {
    margin-top: 5px;
  }

  50% {
    margin-top: -10px;
  }

  100% {
    margin-top: 5px;
  }
}

@keyframes navItemKf {
  0% {
    margin-top: 5px;
  }

  50% {
    margin-top: -10px;
  }

  100% {
    margin-top: 5px;
  }
}

.nav-list2 .entry-box1 .top-img .box-item {
  position: relative;
  margin-left: 10 * 4.2px;

  @media only screen and (max-width: 430px) {
    margin-left: 10vw;
  }
}

.nav-list2 .entry-box1 .top-img .lucky-item {
  margin-left: 18.4 * 4.2px;
  -webkit-animation: navItemKf 2s 0.5s linear infinite;
  animation: navItemKf 2s 0.5s linear infinite;
  background-image: url("../assets/images/nav_2_3.gif");

  @media only screen and (max-width: 430px) {
    margin-left: 18.4vw;
  }
}

.nav-list2 .entry-box1 .top-img .pk-item {
  margin-left: 16.4 * 4.2px;
  -webkit-animation: navItemKf 2s 0.5s linear infinite;
  animation: navItemKf 2s 0.5s linear infinite;
  background-image: url("../assets/images/nav_2_1.gif");

  @media only screen and (max-width: 430px) {
    margin-left: 16.4vw;
  }
}

.nav-list2 .entry-box1 .btm-title {
  margin-top: 2.8 * 4.2px;

  @media only screen and (max-width: 430px) {
    margin-top: 2.8vw;
  }
}

.nav-list2 .entry-box1 .btm-title .tv {
  float: left;
  width: 20.67 * 4.2px;
  height: 5.6 * 4.2px;
  background-size: 100% 100%;

  @media only screen and (max-width: 430px) {
    width: 20.67vw;
    height: 5.6vw;
  }
}

.nav-list2 .entry-box1 .btm-title .box-tv {
  margin-left: 12.4 * 4.2px;
  background-image: url("../assets/images/nav_2_10.png");
  background-repeat: no-repeat;
  background-size: 18.53 * 4.2px 5.2 * 4.2px;

  @media only screen and (max-width: 430px) {
    margin-left: 12.4vw;
    background-size: 18.53vw 5.2vw;
  }
}

.nav-list2 .entry-box1 .btm-title .lucky-tv {
  margin-left: 6.67 * 4.2px;
  background: url("../assets/images/roll.png") center center / 52.08px 18px
    no-repeat;

  @media only screen and (max-width: 430px) {
    margin-left: 6.67vw;
    background: url("../assets/images/roll.png") center center / 12.4vw 4.27vw
      no-repeat;
  }
}

.nav-list2 .entry-box1 .btm-title .pk-tv {
  margin-left: 7.87 * 4.2px;
  background-image: url("../assets/images/nav_2_12.png");
  background-repeat: no-repeat;
  background-size: 18.53 * 4.2px 5.2 * 4.2px;

  @media only screen and (max-width: 430px) {
    margin-left: 7.87vw;
    background-size: 18.53vw 5.2vw;
  }
}
// .swiper {
//   margin: 4 * 4.2px 0 0 0;

//   @media only screen and (max-width: 430px) {
//     margin: 4vw 0 0 0;
//   }
// }

.nav-list2 .entry-box1 .touch-layer {
  position: absolute;
  top: 5.73 * 4.2px;
  left: 0;
  width: 100%;
  height: 19.47 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 0 2.67 * 4.2px;

  @media only screen and (max-width: 430px) {
    top: 5.73vw;
    height: 19.47vw;
    padding: 0 2.67vw;
  }
}

.nav-list2 .entry-box1 .touch-layer .touch-box {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  height: 100%;
}

.nav-list2 .entry-box1 .touch-layer .touch-lucky {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  height: 100%;
  margin: 0 2.67 * 4.2px;

  @media only screen and (max-width: 430px) {
    margin: 0 2.67vw;
  }
}

.nav-list2 .entry-box1 .touch-layer .touch-battle {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  height: 100%;
}

.nav-list2 .entry-box2 {
  position: relative;
  width: 50.67 * 4.2px;
  height: 27.07 * 4.2px;
  margin-top: 6 * 4.2px;
  margin-left: 10px;
  margin: 10px auto;

  @media only screen and (max-width: 430px) {
    width: 50.67vw;
    height: 27.07vw;
    margin-top: 6vw;
  }
}

.nav-list2 .entry-box2 .pk-img {
  width: 50.67 * 4.2px;
  height: 27.07 * 4.2px;
  margin-left: 4 * 4.2px;
  background-size: 100% 100%;
  background-image: url("../assets/images/pk_img.gif");

  @media only screen and (max-width: 430px) {
    width: 50.67vw;
    height: 27.07vw;
    margin-left: 4vw;
  }
}

.nav-list2 .entry-box2 .rotate-img {
  position: absolute;
  top: 0px;
  right: 5.07 * 4.2px;
  width: 26.4 * 4.2px;
  height: 26.4 * 4.2px;
  background-size: 100% 100%;
  background-image: url("../assets/images/rotate_img.png");
  -webkit-animation: rotateImgKf 6s linear infinite;
  animation: rotateImgKf 6s linear infinite;

  @media only screen and (max-width: 430px) {
    top: 0px;
    right: 5.07vw;
    width: 26.4vw;
    height: 26.4vw;
  }
}

@-webkit-keyframes rotateImgKf {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes rotateImgKf {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

.nav-list2 .entry-box2 .bk-img {
  background-position: center bottom;
  background-repeat: no-repeat;
  // background-size: 94.8 * 4.2px 26.8 * 4.2px;
  background-size: contain;
  background-image: url("../assets/images/nav_2_21.png");
  // width: 430px;
  // height: 115px;
  position: absolute;
  bottom: 0;
  z-index: 0;

  @media only screen and (max-width: 430px) {
    // background-size: 94.8vw 26.8vw;
  }
}

.nav-list2 .entry-box2 .lightning-img {
  position: absolute;
  top: 0;
  right: 0;
  width: 37.33 * 4.2px;
  height: 21.6 * 4.2px;
  background-size: 100% 100%;
  background-image: url("../assets/images/lightning_img.gif");

  @media only screen and (max-width: 430px) {
    width: 37.33vw;
    height: 21.6vw;
  }
}

.nav-list2 .entry-box2 .card-img {
  position: absolute;
  top: 2.93 * 4.2px;
  left: 16.67 * 4.2px;
  width: 16.13 * 4.2px;
  height: 14.93 * 4.2px;
  background-size: 100% 100%;
  background-image: url("../assets/images/nav_2_22.gif");

  @media only screen and (max-width: 430px) {
    top: 2.93vw;
    left: 16.67vw;
    width: 16.13vw;
    height: 14.93vw;
  }
}

.nav-list2 .entry-box2 .card-img1 {
  position: absolute;
  top: 2.4 * 4.2px;
  right: 16.67 * 4.2px;
  width: 20.8 * 4.2px;
  height: 18 * 4.2px;
  background-size: 100% 100%;
  background-image: url("../assets/images/nav_index1.gif");

  @media only screen and (max-width: 430px) {
    top: 2.4vw;
    right: 16.67vw;
    width: 20.8vw;
    height: 18vw;
  }
}

.nav-list2 .entry-box2 .layer2-box {
  position: absolute;
  padding-top: 19.73 * 4.2px;
  left: 0;
  top: 0;
  width: 100%;

  @media only screen and (max-width: 430px) {
    padding-top: 19.73vw;
  }
}

.nav-list2 .entry-box2 .layer2-box .tv {
  float: left;
  width: 20.27 * 4.2px;
  height: 6.27 * 4.2px;
  background-size: 100% 100%;

  @media only screen and (max-width: 430px) {
    width: 20.27vw;
    height: 6.27vw;
  }
}

.nav-list2 .entry-box2 .layer2-box .card-tv {
  margin-left: 14.8 * 4.2px;
  margin-top: 0.27 * 4.2px;
  background-image: url("../assets/images/nav_2_31.png");
  background-repeat: no-repeat;
  background-size: 19.07 * 4.2px 5.2 * 4.2px;

  @media only screen and (max-width: 430px) {
    margin-left: 14.8vw;
    margin-top: 0.27vw;
    background-size: 19.07vw 5.2vw;
  }
}

.nav-list2 .entry-box2 .layer2-box .roll-tv {
  margin-left: 26.67 * 4.2px;
  background-image: url("../assets/images/nav_2_32.png");
  background-repeat: no-repeat;
  background-size: 18.53 * 4.2px 5.2 * 4.2px;

  @media only screen and (max-width: 430px) {
    margin-left: 18.53vw;
    background-size: 18.53vw 5.2vw;
  }
}

.nav-list2 .entry-box2 .touch-layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 0 2.67 * 4.2px;

  @media only screen and (max-width: 430px) {
    padding: 0 2.67vw;
  }
}

.nav-list2 .entry-box2 .touch-layer .touch-card {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  height: 100%;
}

.nav-list2 .entry-box2 .touch-layer .touch-roll {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  height: 100%;
}

@media only screen and (max-width: 430px) {
  .entry-box1 .top-img .img {
    width: 16vw;
    height: 14vw;
  }
}
</style>
